import { useState, useEffect } from "react";
import { useServiceCustomer } from "../../contexts/service-customer-context";
import { DeleteReportType } from "../../models";
import React from "react";

interface SummaryData {
  type: string;
  count: number;
}

interface Summary {
  title: string;
  data: SummaryData[];
}

const SummaryPractices = () => {
  const { getServiceCustomerSummary } = useServiceCustomer();

  const [summary, setSummary] = useState<Map<string, Summary>>(new Map());

  useEffect(() => {
    const loadSummaries = async () => {
      try {
        const [
          cqsSummary,
          loansSummary,
          debtsSummary,
          screeningSummary,
          deleteReportSummary,
          tributaryScreeningSummary,
          revolvingCardSummary,
          finanthiaSummary,
          erogazioniSummary,
        ] = await Promise.all([
          getServiceCustomerSummary("RecuperoCessione", true),
          getServiceCustomerSummary("RecuperoPrestito", true),
          getServiceCustomerSummary("GestioneDebitoria", true),
          getServiceCustomerSummary("Screening", false),
          getServiceCustomerSummary(DeleteReportType.DELETEREPORTALL, true),
          getServiceCustomerSummary("Tributario", false),
          getServiceCustomerSummary("RecuperoCR", true),
          getServiceCustomerSummary("Finanthia", true),
          getServiceCustomerSummary("Erogazioni", true),
        ]);

        const summaries = new Map<string, Summary>([
          ["cqs", { title: "Pratiche CQS", data: cqsSummary.data }],
          [
            "loans",
            { title: "Pratiche Prestito Personale", data: loansSummary.data },
          ],
          [
            "debts",
            { title: "Pratiche Gestione Debito", data: debtsSummary.data },
          ],
          [
            "screening",
            { title: "Pratiche Screening", data: screeningSummary.data },
          ],
          [
            "deleteReport",
            { title: "Pratiche Cancellazioni", data: deleteReportSummary.data },
          ],
          [
            "tributaryScreening",
            {
              title: "Pratiche Screening Tributario",
              data: tributaryScreeningSummary.data,
            },
          ],
          [
            "revolvingCard",
            {
              title: "Pratiche Carte Revolving",
              data: revolvingCardSummary.data,
            },
          ],
          [
            "finanthia",
            {
              title: "Pratiche Finanthia",
              data: finanthiaSummary.data,
            },
          ],
          [
            "erogazioni",
            {
              title: "Pratiche Erogazioni",
              data: erogazioniSummary.data,
            },
          ],
        ]);

        setSummary(summaries);
      } catch (error) {
        console.error("Error loading", error);
      }
    };

    loadSummaries();
  }, [getServiceCustomerSummary]);

  return (
    <div className="practices-home-page">
      <div className="row">
        <div className="col-12 mb-3 text-center">
          <h3>Pratiche</h3>
        </div>
        {Array.from(summary.entries()).map(([key, value], index) => (
          <React.Fragment key={`${key}_${index}`}>
            {!!value.data && (
              <>
                <div className="col-12 col-md-6 col-lg-4 mb-5">
                  <h5 className="fw-bold">{value.title}</h5>
                  <hr />
                  <div style={{ overflow: "auto", maxHeight: 280 }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Stato Pratica</th>
                          <th>N. Pratiche</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.data.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.type}</td>
                              <td>{item.count}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SummaryPractices;
